export default () => ({
  show: false,
  statusAddress: null,
  statusStaff: null,
  statusPrice: null,
  includes: [
    'address.company',
    'company',
    'professional',
    'covenants',
    'specialities',
    'countrules'
  ],
  nextStepButtonAddress: [
    {
      icon: '',
      text: 'Cadastrar Local de Atendimento',
      name: 'professional.company.addresses.index',
      action: null
    }
  ],
  nextStepButtonPrices: [
    {
      icon: '',
      text: 'Cadastrar Honorário',
      name: 'professional.company.prices.index',
      action: null
    }
  ]
})



// WEBPACK FOOTER //
// ./src/app/professional/agenda/agendas/index/resources/data.js